import { Timestamp } from 'google-protobuf/google/protobuf/timestamp_pb'
import React, { useContext, useMemo, useState } from 'react'

type OnUpdateRelevantDate = () => void

type CurrentEvidence = {
  evidenceId: string // this is now the evidence instance id
  setEvidenceId: React.Dispatch<React.SetStateAction<string>>
  relevantDate?: Timestamp
  setRelevantDate: React.Dispatch<React.SetStateAction<Timestamp | undefined>>
  controlModelIds: string[]
  setControlModelIds: React.Dispatch<React.SetStateAction<string[]>>
  onUpdateRelevantDate?: OnUpdateRelevantDate
  setOnUpdateRelevantDate: React.Dispatch<
    React.SetStateAction<OnUpdateRelevantDate | undefined>
  >
}

const CurrentEvidenceContext = React.createContext<CurrentEvidence>({
  evidenceId: '',
  setEvidenceId: () => '',
  relevantDate: undefined,
  setRelevantDate: () => undefined,
  controlModelIds: [],
  setControlModelIds: () => [],
  onUpdateRelevantDate: undefined,
  setOnUpdateRelevantDate: () => undefined,
})

export const useCurrentEvidenceId = (): CurrentEvidence =>
  useContext(CurrentEvidenceContext)

export const CurrentEvidenceContextProvider = ({
  children,
}: {
  children: JSX.Element
}): JSX.Element => {
  const [evidenceId, setEvidenceId] = useState<string>('')
  const [relevantDate, setRelevantDate] = useState<Timestamp | undefined>(
    undefined,
  )
  const [controlModelIds, setControlModelIds] = useState<string[]>([])
  const [onUpdateRelevantDate, setOnUpdateRelevantDate] = useState<
    OnUpdateRelevantDate | undefined
  >(undefined)

  const evidenceData: CurrentEvidence = useMemo(
    () => ({
      evidenceId,
      setEvidenceId,
      relevantDate,
      setRelevantDate,
      controlModelIds,
      setControlModelIds,
      onUpdateRelevantDate,
      setOnUpdateRelevantDate,
    }),
    [
      evidenceId,
      setEvidenceId,
      relevantDate,
      setRelevantDate,
      controlModelIds,
      setControlModelIds,
      onUpdateRelevantDate,
      setOnUpdateRelevantDate,
    ],
  )
  return (
    <CurrentEvidenceContext.Provider value={evidenceData}>
      {children}
    </CurrentEvidenceContext.Provider>
  )
}
